import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CoreTargetService {
  private selectedTarget: Record<string, any> = {};
  private readonly targetChanges = new Subject<void>();
  readonly targetChanges$ = this.targetChanges.asObservable();

  public setSelectedTarget(key: string, value: any): void {
    this.selectedTarget = {
      ...this.selectedTarget,
      [key]: value,
    };

    sessionStorage.setItem(key, value);

    if (key === 'target') this.targetChanges.next();
  }

  public getSelectedTarget(key: string): any {
    const selectedValue = this.selectedTarget?.[key];

    if (key == 'target' && !selectedValue && sessionStorage.getItem(key)) {
      return sessionStorage.getItem(key);
    }

    return this.selectedTarget?.[key];
  }
}
